<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Age Verification</v-card-title>
      <v-card-text>I am at least 21 years old.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="dialog = false, cookie()">Yes</v-btn>
        <v-btn color="green darken-1" text href="https://en.wikipedia.org/wiki/Minors_and_the_legality_of_cannabis">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: true,
      ageCookie: null
    };
  },
  methods: {
    cookie() {
      this.$cookie.set('ageVerified', true, {expires: '7D'})
    },
    checkCookie(){
      var x = this.$cookie.get('ageVerified')
      console.log(x)
      if (x) {
        this.dialog = false
      }
    }
  },
  mounted() {
    this.checkCookie()
  }
};
</script>